import { useMemo } from 'react';
import { UseQueryResult } from 'react-query';
import { Events, Videos } from 'src/graphql/schema.graphql';
import { videosBasicGqlQuery } from 'src/modules/videos/graphql/videos-basic.query';
import { videoDetailsGqlQuery } from 'src/modules/videos/graphql/videos-details.query';
import { useVideosListQuery } from 'src/modules/videos/hooks/useVideosListQuery';
import { RequiredDeep } from 'ts-toolbelt/out/Object/Required';

export const useEventRelatedVideosListQuery = ({
  event,
  limit = -1,
  detailed = false,
}: {
  event: Events | undefined;
  limit?: number;
  detailed?: boolean;
}): UseQueryResult<RequiredDeep<Videos>[], unknown> => {
  const tagsIDs = useMemo(
    () => event?.tags?.map((tag) => tag.tags_id.id).slice(0, 1) ?? [],
    [event?.tags],
  );

  const videos = useVideosListQuery(
    detailed ? videoDetailsGqlQuery : videosBasicGqlQuery,
    {
      filters: {
        tags: {
          tags_id: {
            id: {
              _in: tagsIDs,
            },
          },
        },
        status: { _eq: 'published' },
        showcase: { _eq: true },
      },
      limit,
      sort: ['-date_created'],
    },
    { enabled: tagsIDs.length > 0 },
  );

  return videos;
};
